import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, ElementRef, Injector, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from '../confirmation-popup/confirmation-popup.component';
import { saveAs } from 'file-saver';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

import { HandbookviewComponent } from '../handbookview/handbookview.component';
import { LandingPageVideoComponent } from 'src/app/hradmin/landing-page-video/landing-page-video.component';
import { ViewLandingPageVideoTableComponent } from 'src/app/hradmin/view-landing-page-video-table/view-landing-page-video-table.component';
import { ViewLandingPageVideoComponent } from 'src/app/hradmin/view-landing-page-video/view-landing-page-video.component';
import { MatTableDataSource } from '@angular/material/table';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { environment } from 'src/environments/environment';
export interface Video {
  srNo: number;
  title: string;
  description: string;
  attachment?: string;
}
@Component({
  selector: 'app-home-quick-search-popup',
  templateUrl: './home-quick-search-popup.component.html',
  styleUrls: ['./home-quick-search-popup.component.scss']
})
export class HomeQuickSearchPopupComponent implements OnInit {
  @ViewChild('browseImage') browseImage: ElementRef | undefined;
  statusCheck: any;
  fileName: any = null;
  fileType: any = null;
  formData: any = new FormData();
  letterHeadUrl: any;
  isFileSizeIsInvalid: boolean = false;
  loggedInUserCompanyID: any;
  searchEmployee: any;
  getEmployeeSearchData: any = [];
  buttonColorName: any;
  showBrowseBtn: boolean = false;
  handbookFileData: any = [];
  isShowUploadUserManual: any = false;
  loggedInUserRole: any;
  isDisabledUploadPolicyBtn: boolean = true;

  constructor(
    private injector: Injector,
    private httpService: HttpService,
    private config: Config,
    private encryptionService: EncryptionService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    public mobileResponsiveService: MobileResponsiveService
  ) {}

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    const dialogData = this.injector.get(MAT_DIALOG_DATA);
    this.statusCheck = dialogData.statusCheck;
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.statusCheck == 'employeeSearch') {
      this.getEmployeeSearch();
    }
    this.getHrHandBookFileData();
    this.getHrHelpDesk();
    this.getData();
  }

  ionViewWillEnter() {}

  getEmployeeSearch() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      entityName: null,
      search: this.searchEmployee || null,
      status: 1,
      userType: null
    };
    this.httpService.callPostService(this.config.searchEmployeeMaster, request).subscribe((result: any) => {
      this.getEmployeeSearchData = result.data.users;
    });
  }

  onEmployeeSearch(data: any) {
    var search = '';
    this.searchEmployee = data;
    if (data == '') {
      this.searchEmployee = null;
      this.getEmployeeSearch();
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getEmployeeSearch();
          }, 500);
        }
      }, 1500);
    }
  }

  triggerFileInput() {
    const fileInput: any = document.getElementById('fileInput') as HTMLInputElement;
    fileInput.click();
  }

  // onFileSelected(event: Event) {
  //   const inputEvent:any = event.target as HTMLInputElement;
  //   this.fileName = null;
  //   this.fileType = null;
  //   this.formData = new FormData();
  //   // const fileSizeInKB = inputEvent.files[0].size / 1024;
  //   // const fileSizeInMB = fileSizeInKB / 1024;
  //   if (!inputEvent.files[0] || inputEvent.files[0].length == 0) {
  //     return;
  //   }
  //   if (inputEvent.files[0].name.includes('csv') && !inputEvent.files[0].name.includes('CSV') && !inputEvent.files[0].name.includes('xlsx') && !inputEvent.files[0].name.includes('XLSX')) {
  //     window.alert("File format is not supported");
  //     return;
  //   }
  //   // if (fileSizeInMB > 10) {
  //   //   window.alert("File size is greater than 10MB");
  //   //   return;
  //   // }
  //     if (inputEvent.files[0]) {
  //       this.fileName = inputEvent.files[0].name;
  //       this.fileType = inputEvent.files[0].type;
  //       this.formData = new FormData();
  //       this.formData.append('file', inputEvent.files[0]);
  //       this.formData.append('companyId', this.loggedInUserCompanyID);
  //       this.showBrowseBtn = true;
  //       this.isFileSizeIsInvalid = false;
  //       const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
  //       this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
  //         this.letterHeadUrl=data?.data;
  //       })
  //     }
  // }

  onClickShowUploadUserManual() {
    this.isShowUploadUserManual = !this.isShowUploadUserManual;
  }

  // onFileSelected(event: Event) {
  //   const inputEvent: any = event.target as HTMLInputElement;
  //   this.fileName = null;
  //   this.fileType = null;
  //   this.formData = new FormData();
  //   if (!inputEvent.files || inputEvent.files.length === 0) {
  //     return;
  //   }
  //   const selectedFile = inputEvent.files[0];
  //   const fileName = selectedFile.name.toLowerCase();
  //   const fileType = selectedFile.type;
  //   const supportedFormats = ['png', 'jpeg', 'jpg', 'pdf', 'XLSX', 'xlsx'];
  //   const fileExtension = fileName.split('.').pop();
  //   if (!supportedFormats.includes(fileExtension)) {
  //     window.alert("File format is not supported. Please upload png, jpeg, jpg, excel or pdf.");
  //     return;
  //   }
  //   this.fileName = selectedFile.name;
  //   this.fileType = selectedFile.type;
  //   this.formData = new FormData();
  //   this.formData.append('file', selectedFile);
  //   this.formData.append('companyId', this.loggedInUserCompanyID);
  //   this.showBrowseBtn = true;
  //   this.isDisabledUploadPolicyBtn = false;
  //   this.isFileSizeIsInvalid = false;
  //   const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
  //   this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
  //     this.letterHeadUrl = data?.data;
  //   });
  // }

  //  code for Help Desk
  onFileSelected(event: Event) {
    const inputEvent: any = event.target as HTMLInputElement;
    this.fileName = null;
    this.fileType = null;
    this.formData = new FormData();

    if (!inputEvent.files || inputEvent.files.length === 0) {
      return;
    }

    const selectedFile = inputEvent.files[0];
    const fileName = selectedFile.name.toLowerCase();
    const fileType = selectedFile.type;
    const fileSizeInMB = selectedFile.size / (1024 * 1024); // convert bytes → MB

    // ✅ Only allow pdf, png, jpg
    const supportedFormats = ['pdf', 'png', 'jpg'];
    const fileExtension = fileName.split('.').pop();

    if (!fileExtension || !supportedFormats.includes(fileExtension)) {
      window.alert('File format is not supported. Please upload pdf, png or jpg.');
      return;
    }

    // ✅ Restrict file size to max 10MB
    if (fileSizeInMB > 10) {
      window.alert('File size must not exceed 10 MB.');
      return;
    }

    this.fileName = selectedFile.name;
    this.fileType = selectedFile.type;
    this.formData = new FormData();
    this.formData.append('file', selectedFile);
    this.formData.append('companyId', this.loggedInUserCompanyID);
    this.showBrowseBtn = true;
    this.isDisabledUploadPolicyBtn = false;
    this.isFileSizeIsInvalid = false;

    const url = this.config.uploadFileLocally + `?fileName=${this.fileName}&fileType=${this.fileType}`;
    this.httpService.submitFormService(url, this.formData).subscribe((data: any) => {
      this.letterHeadUrl = data?.data;
    });
  }

  onClickOpenTickets() {
    const tickets = `https://wwwcatalystdevphiedgecoin.raiseaticket.com/support/#/newticket`;
    window.open(tickets, '_blank');
  }

  onClickSaveUserManualFile() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      data: {
        msg: 'File is uploaded.',
        btn2: 'Done',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        const request = {
          companyId: this.loggedInUserCompanyID,
          fileName: this.fileName,
          id: null,
          url: this.letterHeadUrl
        };
        this.httpService.callPostService(this.config.setUserManual, request).subscribe((result: any) => {
          this.getHrHelpDesk();
          this.showBrowseBtn = false;
          this.isDisabledUploadPolicyBtn = true;
        });
      }
    });
  }

  downloadUserManual() {
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((result: any) => {
      const downloadFile: any = result?.data;
      if (downloadFile.userManualUrl) {
        var filename = downloadFile.userManualUrl.split(environment.downloadURL);
        saveAs(downloadFile.userManualUrl, filename[1]);
        // saveAs(environment.downloadURL+downloadFile.userManualUrl,downloadFile.userManualUrl);
      }
    });
  }

  onCloseFile() {
    this.showBrowseBtn = false;
    this.isDisabledUploadPolicyBtn = false;
  }

  onClickSaveHrHandbookFile() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      data: {
        msg: 'File is uploaded.',
        btn2: 'Done',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: true,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      const request = {
        companyId: this.loggedInUserCompanyID,
        fileName: this.fileName,
        id: null,
        url: this.letterHeadUrl
      };
      this.httpService.callPostService(this.config.setHrHandbook, request).subscribe((result: any) => {
        if (result) {
          this.getHrHandBookFileData();
          this.showBrowseBtn = false;
          this.fileName = null;
          this.fileType = null;
          this.letterHeadUrl = null;
          this.formData = new FormData();
          this.isDisabledUploadPolicyBtn = true;

          if (this.browseImage && this.browseImage.nativeElement) {
            this.browseImage.nativeElement.value = '';
          }
        }
      });
    });
  }

  getHrHandBookFileData() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: this.searchEmployee
    };
    this.httpService.callPostService(this.config.getByCompanyIdHrHandbook, request).subscribe((result: any) => {
      this.handbookFileData = [];
      this.handbookFileData = result?.data?.map((ele: any) => ({
        id: ele.id,
        handbookFileName: ele.handbookFileName,
        handbookUrl: ele.handbookUrl
      }));
    });
  }
  helpDeskFileData: any = [];
  getHrHelpDesk() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      search: this.searchEmployee
    };
    this.httpService.callPostService(this.config.getByCompanyIdUserManual, request).subscribe((result: any) => {
      this.helpDeskFileData = [];
      this.helpDeskFileData = result?.data?.map((ele: any) => ({
        id: ele.id,
        userManualFileName: ele.userManualFileName,
        userManualUrl: ele.userManualUrl
      }));
    });
  }
  viewHandBookFile(handbookUrl: string, fileName: string) {
    // window.open(handbookUrl, '_blank');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '80%';
    dialogConfig.width = '80%';
    dialogConfig.data = {
      url: handbookUrl,

      fileName: fileName
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(HandbookviewComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {});
  }
  videos: Video[] = [];
  dataSource!: MatTableDataSource<Video>;

  getData() {
    this.httpService.callGetService(`${this.config.getVideos}`).subscribe((res: any) => {
      console.log(res);

      // Assign serial numbers dynamically
      res.forEach((video: any, index: number) => {
        video.srNo = index + 1;
      });

      // Assign to MatTableDataSource
      this.dataSource = new MatTableDataSource(res);
    });
  }

  checkClickOnDIY: any;
  // addVideo() {

  //   this.checkClickOnDIY = 'DIY';

  //   if (this.loggedInUserRole === 'Super Admin' ) {

  //     const dialogConfig = new MatDialogConfig();
  //     // dialogConfig.height = '80%';
  //     // dialogConfig.width = '80%';
  //     // dialogConfig.panelClass = 'custom-dialog-container';

  //     dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidth1300AndBelow;
  //     dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
  //     dialogConfig.data = {
  //       showData: this.dataSource
  //     };
  //     const dialogRef = this.dialog.open(ViewLandingPageVideoTableComponent, dialogConfig);

  //     dialogRef.afterClosed().subscribe(() => {
  //       this.isShowUploadUserManual = false;
  //       this.checkClickOnDIY = null;
  //     });

  //   } else {
  //     const dialogConfig = new MatDialogConfig();
  //     // dialogConfig.height = '80%';
  //     // dialogConfig.width = '80%';
  //     // dialogConfig.panelClass = 'custom-dialog-container';

  //     dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidth1300AndBelow;
  //     dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
  //     dialogConfig.data = {
  //       showData: this.dataSource
  //     };

  //     const dialogRef = this.dialog.open(ViewLandingPageVideoComponent, dialogConfig);
  //     dialogRef.afterClosed().subscribe(() => {
  //       this.isShowUploadUserManual = false;
  //       this.checkClickOnDIY = null;
  //     });

  //   }
  // }

  addVideo() {
    this.checkClickOnDIY = 'DIY';

    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '80%';
    // dialogConfig.width = '80%';
    // dialogConfig.panelClass = 'custom-dialog-container';

    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidth1300AndBelow;
    dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
    dialogConfig.data = {
      showData: this.dataSource
    };
    const dialogRef = this.dialog.open(ViewLandingPageVideoTableComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(() => {
      this.isShowUploadUserManual = false;
      this.checkClickOnDIY = null;
    });
  }
  showVideo() {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.height = '80%';
    // dialogConfig.width = '80%';
    // dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.disableClose = false;

    dialogConfig.maxWidth = this.mobileResponsiveService.modelMaxWidth1300AndBelow;
    dialogConfig.panelClass = ['phi_mdc_dialog__container_100_phi_mdc_dialog__content_85_vh'];
    const dialogRef = this.dialog.open(ViewLandingPageVideoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(() => {
      this.isShowUploadUserManual = false;
      this.checkClickOnDIY = null;
    });
  }

  downloadHandBookFile(handbookUrl: any, fileName: any) {
    if (handbookUrl) {
      saveAs(handbookUrl, fileName);
    }
  }

  closeother() {
    this.isShowUploadUserManual = false;
  }

  onClickDeleteHandbookFile(id: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      data: {
        msg: 'Are you sure you want to delete',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.httpService.callGetService(this.config.deleteHrHandbook + id).subscribe(result => {
          if (result) {
            this.getHrHandBookFileData();
          }
        });
      }
    });
  }

  onClickDeleteHelpDesk(id: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      data: {
        msg: 'Are you sure you want to delete',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.httpService.callGetService(this.config.deleteHrHelpDesk + id).subscribe(result => {
          if (result) {
            this.getHrHelpDesk();
          }
        });
      }
    });
  }

  onHandbookFileSearch(data: any) {
    var search = '';
    this.searchEmployee = data;
    if (data == '') {
      this.searchEmployee = null;
      this.getHrHandBookFileData();
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            this.getHrHandBookFileData();
          }, 500);
        }
      }, 1500);
    }
  }
}
